module.exports = __webpack_public_path__ + "img/cdq2b40-2.prt.bd58d243.jpg";